<template>
  <div>
    <div class="div_border PRODUCTMAIN">
    <label for="file-upload-main" v-if="logged_in"  class="custom-file-upload" >    <i class="fa fa-cloud-upload"></i> </label>
    <input id="file-upload-main" v-if="logged_in" type="file" @change="uploadFileimg"  class=" active_input ">    
             
      <CollectionTitle />
      <FamilyTitle />
      <ProductCounterTitle />
    </div>
    <!-- <ModelsListSelector /> -->
  </div>
</template>
<script>
import CollectionTitle from "./productPage/titles/collectionTitle.vue";
import FamilyTitle from "./productPage/titles/familyTitle.vue";
import ProductCounterTitle from "./productPage/titles/productCounterTitle.vue";
// import ModelsListSelector from "./productPage/main/modelsListSelector.vue";
import logged_in from "../classes/logged_in";
export default {
  name: "productMain",
  data: () => ({
    logged_in: false,
  }),
  mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type == "logged_in") {
        this.logged_in = true;
        console.info('productMain');
      }
    });
  },
  methods:{
  
    uploadFileimg(event) {
        let l = new  logged_in();
        l.uploadFileP(event.target.files[0], this.$store.state.product_store.CODICE_UNIVOCO).then( (response) =>{
          console.log(response);
          setTimeout( () =>{ location.reload()}, 1500 )
        })
      },
  },
  // PRODUCT PAGE COMPONENTS
  components: {
    CollectionTitle,
    FamilyTitle,
    ProductCounterTitle,
    // ModelsListSelector
  },
};
</script>
<style scoped>
.not_active_input{
  display: none;
}
.active_input{
   
    position: absolute;
    left: -11px;
}
input[type="file"] {
    display: none;
}
.custom-file-upload {
  opacity: 0.1;
    display: inline-block;
    cursor: pointer;
    position: absolute;
    left: -68px;
    top: 0px;

}
.custom-file-upload:hover {
  opacity: 1;
}
</style>